import { useMemo } from "react";
import { useSelector } from "react-redux";
import { MenuHeader } from "./MenuHeader";

const CustomMenu = ({ children }) => {
    const proyectSelected = useSelector((state) => state.vrlSlice.proyectSelected);

    const color = useMemo(() => {
        switch (proyectSelected?._id) {
            case "6610c73702c6d8edebbe9154":
            case "66155e601e91fe7bde671941":
                return "bg-gradient-to-t from-[#23477D] to-[#0B214D] text-white";
            default:
                return "bg-white text-3366FF shadow-xl";
        }
    }, [proyectSelected?._id]);


    return (
        <div className={`h-full min-w-[207px] w-[207px] flex flex-col relative float-left ${color}`}>
            <MenuHeader />
            {children}
        </div>
    );
};

export default CustomMenu;
